/**
 * Rotas da camada operacional (barra OperationalNavBar). Centralizadas aqui para que o
 * menu lateral, a barra, os redirecionamentos e os links entre telas nunca divirjam.
 */

export const OPERATIONAL_HOME = "/secure/home"

export const OPERATIONAL_ROUTES = {
  home: OPERATIONAL_HOME,
  schedule: "/secure/schedule",
  fill: "/secure/tasks",
  analysis: "/secure/analysis",
  events: "/secure/events",
} as const

export type OperationalTab = keyof typeof OPERATIONAL_ROUTES

export type AnalysisView = "submissions" | "schedules"

export interface AnalysisLinkFilters {
  taskId?: string | null
  resourceId?: string | null
  /** Submissões: userId (createdBy). Agendamentos: workspaceMemberId (responsável). */
  userId?: string | null
  status?: string | null
}

/** Link para "Análise" já com a visão e os filtros aplicados (somente chaves preenchidas). */
export function analysisHref(view: AnalysisView, filters: AnalysisLinkFilters = {}): string {
  const query = new URLSearchParams({ view })
  if (filters.taskId) query.set("taskId", filters.taskId)
  if (filters.resourceId) query.set("resourceId", filters.resourceId)
  if (filters.userId) query.set("userId", filters.userId)
  if (filters.status) query.set("status", filters.status)
  return `${OPERATIONAL_ROUTES.analysis}?${query.toString()}`
}

export function eventsHref(filters: { taskId?: string | null; status?: string | null } = {}): string {
  const query = new URLSearchParams()
  if (filters.taskId) query.set("taskId", filters.taskId)
  if (filters.status) query.set("status", filters.status)
  const suffix = query.toString()
  return suffix ? `${OPERATIONAL_ROUTES.events}?${suffix}` : OPERATIONAL_ROUTES.events
}

/**
 * Destino do "Voltar" das telas de preenchimento/detalhe de submissão (`details/view`,
 * `details/submission`), a partir do parâmetro `from` com que foram abertas.
 */
export function detailBackHref(params: URLSearchParams | { get(name: string): string | null }): string {
  const from = params.get("from")
  if (from === "schedule") return OPERATIONAL_ROUTES.schedule
  if (from === "analysis") {
    const view = params.get("view") === "schedules" ? "schedules" : "submissions"
    return analysisHref(view)
  }
  if (from === "events") return OPERATIONAL_ROUTES.events
  return OPERATIONAL_ROUTES.fill
}

/** Qual aba da barra operacional corresponde a um caminho (para realce). */
export function operationalTabForPath(pathname: string): OperationalTab | null {
  const path = pathname.replace(/\/+$/, "")
  if (path === OPERATIONAL_ROUTES.home) return "home"
  if (path === OPERATIONAL_ROUTES.schedule) return "schedule"
  if (path === OPERATIONAL_ROUTES.fill) return "fill"
  if (path.startsWith(OPERATIONAL_ROUTES.analysis)) return "analysis"
  if (path.startsWith(OPERATIONAL_ROUTES.events)) return "events"
  return null
}
